module.exports = {"654004001":"卡拉苏街道","654004002":"亚欧东路街道","654004003":"亚欧西路街道","654004004":"工业园区街道","654004200":"伊车嘎善乡","654004400":"格干沟牧场","654004401":"莫乎尔牧场","654004505":"兵团六十一团","654004506":"兵团六十二团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654004.json
// module id = 3127
// module chunks = 0